"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundary = void 0;
var React = require("react");
var bernie_logger_1 = require("bernie-logger");
var bernie_core_1 = require("bernie-core");
var bernie_core_2 = require("bernie-core");
var ERROR_TIMEOUT = 2000;
var logBuffer = (function () {
    if (typeof window === 'undefined') {
        return null;
    }
    var errors = {};
    var timer;
    var onErrorCount = 0;
    return function (logger, errorString, info, label) {
        if (logger === void 0) { logger = bernie_logger_1.NOOP_LOGGER; }
        if (label && !errors[label]) {
            var error = new Error("ErrorBoundary ".concat(label));
            error.stack = "".concat(errorString, " errorBoundaryLabel=").concat(label, " errorBoundaryDetails=").concat(JSON.stringify(info));
            errors[label] = error;
        }
        else {
            onErrorCount++;
        }
        if (!timer) {
            timer = setTimeout(function () {
                for (var key in errors) {
                    if (Object.prototype.hasOwnProperty.call(errors, key)) {
                        errors[key].message += " onErrorCount=".concat(onErrorCount);
                        if (typeof window !== 'undefined' && logger) {
                            logger.logEvent(bernie_core_1.BERNIE_CORE_EVENTS.REACT_ROUTE_ERROR, (0, bernie_logger_1.getErrorString)(errors[key]));
                        }
                    }
                }
                errors = {};
                onErrorCount = 0;
                timer = null;
            }, ERROR_TIMEOUT);
        }
    };
})();
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            renderError: null,
            renderErrorInfo: null,
        };
        return _this;
    }
    ErrorBoundary.prototype.componentDidCatch = function (error, info) {
        this.setState({
            renderError: error,
            renderErrorInfo: info,
        });
        logBuffer(this.props.logger, error, info, this.props.label);
    };
    ErrorBoundary.prototype.render = function () {
        if (this.state.renderError) {
            if (this.props.fallback && React.isValidElement(this.props.fallback)) {
                return this.props.fallback;
            }
            return null;
        }
        return this.props.children;
    };
    ErrorBoundary = __decorate([
        (0, bernie_core_2.logger)('errorBoundary')
    ], ErrorBoundary);
    return ErrorBoundary;
}(React.Component));
exports.ErrorBoundary = ErrorBoundary;
//# sourceMappingURL=error-boundary.js.map